import { HubSectionType } from '@alucio/aws-beacon-amplify/src/models';

export const getAvailableWidgetOptions = <T extends { id: HubSectionType }>(
  options: T[],
  isDisabled: (type: HubSectionType) => boolean,
): T[] => options.filter(option => !isDisabled(option.id));
